import { BusinessObjectBase } from './base';
import type { Interview } from './interview';

export interface InterviewTeamworkData {
  readonly id: number;
  readonly teamworkScore?: number;
  readonly leadershipScore?: number;
  readonly notes?: string;
  readonly interviewId: number;
  readonly interview?: Interview;
}

export interface InterviewTeamwork extends Readonly<InterviewTeamworkData> {}
export class InterviewTeamwork extends BusinessObjectBase {
  static readonly entityName = 'InterviewTeamwork' as const;
  static readonly plural = 'interview-teamworks';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<InterviewTeamwork[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new InterviewTeamwork(data));
  }

  static async findOne(filter?: any): Promise<InterviewTeamwork | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new InterviewTeamwork(data) : null;
  }

  static async findById(id: number, filter?: any): Promise<InterviewTeamwork> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new InterviewTeamwork(data);
  }

  static async create(
    data: Omit<InterviewTeamworkData, 'id'>,
  ): Promise<InterviewTeamwork> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new InterviewTeamwork(result);
  }

  static async updateById(
    id: number,
    data: Partial<InterviewTeamworkData>,
  ): Promise<InterviewTeamwork> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new InterviewTeamwork(result);
  }

  static async deleteById(id: number): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
